// Мост LC-экранов — ТОТ ЖЕ протокол, что у cef/lc (bridge.js):
//   действия → rage-rpc 'lc:nui' {cb, data}, фолбэк mp.trigger('lc:nui', cb, json);
//   данные   ← window 'message' (клиент шлёт browser.execute → postMessage).
// Благодаря этому клиент и сервер не отличают перенесённые экраны от React-версии.
export function nuiPost(name, data = {}) {
  try {
    if (window.rpc && typeof window.rpc.callClient === 'function') {
      return window.rpc.callClient('lc:nui', { cb: name, data }).catch(() => ({}));
    }
    if (window.mp && typeof window.mp.trigger === 'function') {
      window.mp.trigger('lc:nui', name, JSON.stringify(data));
      return Promise.resolve({});
    }
  } catch (e) { /* вне игры действий нет — экраны живут на моках */ }
  return Promise.resolve({});
}

// use:autofocus={условие} — автофокус поля при появлении (аналог autoFocus в React)
export function autofocus(node, enabled = true) {
  if (enabled) setTimeout(() => { try { node.focus(); } catch (e) {} }, 30);
  return {};
}
